export default __webpack_public_path__ + "static/media/zucchini.ece37405.png";